import { Form, message, Col, Modal } from 'antd';
import * as React from 'react';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { document, createCompany, network } from 'src/api';
import { history } from 'kts-platform-frame/routes';
import { IRequestParams } from 'kts-platform-frame/display/part/CompanySelection';
import { Field } from 'kts-scaffold-framework/utils/doc';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import AppSdk from 'kts-platform-frame/appSdk';
import moment from 'moment';

import { serverDomain } from 'kts-platform-frame/entry/configUtils';
import { Urls } from 'kts-platform-frame/entry/constant';
import { reducers, MyStore } from 'kts-platform-frame/redux';

import UITemplateFormItem from './UI.TemplateFormItem';

class ModulesAction extends ActionBasic<ModulesState> {
    /**
     * 初始化 
     */
    public initData = (type: string, uuid: string, recordSearch: any) => {
        this.modulesState.documentType = type;
        this.modulesState.recordSearch = recordSearch;
        this.setModulesState(this.modulesState, () => {
            if (uuid === 'create') {
                // 新建
                this.documentDraftGet();
            } else {
                // 修改
                this.modulesState.documentUUID = uuid;
                this.setModulesState(this.modulesState, () => {
                    this.getDocument();
                });
            }

        });
    }
    /**
     * 获取数据 (编辑)
     */
    public getDocument = async () => {
        const param = {
            uuid: this.modulesState.documentUUID,
        };
        const reData: any = await document.documentGetLatest(this, param);
        if (!reData.er) {

            switch (this.modulesState.documentType) {
                case 'Order':
                    this.modulesState.orderForm = reData.res.doc;
                    break;
                case 'Contract':
                    this.modulesState.ContractForm = reData.res.doc;
                    break;
                case 'ForecastDemand':
                case 'ForecastPrediction':
                    this.modulesState.forecastForm = reData.res.doc;
                    break;
                case 'DespatchAdvice':
                    this.modulesState.despatchAdviceForm = reData.res.doc;
                    break;
                case 'ReceiptAdvice':
                case 'ReceiptAdviceRATC01':
                case 'ReceiptAdviceReturn':
                    this.modulesState.receiptAdviceForm = reData.res.doc;
                    break;
                case 'StockInNotice':
                    this.modulesState.stockInNoticeForm = reData.res.doc;
                    break;
                default:
                    break;
            }
            // 单据规则
            this.modulesState.rules = reData.res.rules;
            // 上传文件列表
            this.modulesState.uploadList = reData.res.doc.Attachments;

            // 添加需要验证的字段
            this.addValidateKeys(reData.res.rules);

            // 设置table 表单唯一key
            this.modulesState.linesKey = [];
            reData.res.doc.Lines.forEach((val, index) => {
                this.modulesState.linesKey.push(index);
            });
            // 拼装数据 已上传到 数据
            this.modulesState.uploadList = this.modulesState.uploadList.map((item) => {
                return {
                    ...item,
                    size: 1,
                    status: "done",
                    uid: item.UUID,
                    name: item.FileName,
                    url: `javascript:window.documentAttachmentGet('${item.UUID}');`,
                };
            });
            this.setModulesState(this.modulesState, () => {
                this.getCountry();
            });
        } else {
            this.goBack();
        }

    }

    /**
     * 初始化 单据类型 (新建)
     */
    public documentDraftGet = async () => {
        const param = {
            docType: this.modulesState.documentType,
        };
        const reData: any = await document.documentDraftGet(this, param);
        if (!reData.er) {
            switch (this.modulesState.documentType) {
                case 'Order':
                    this.modulesState.orderForm = reData.res.doc;
                    break;
                case 'Contract':
                    this.modulesState.ContractForm = reData.res.doc;
                    break;
                case 'ForecastDemand':
                case 'ForecastPrediction':
                    this.modulesState.forecastForm = reData.res.doc;
                    break;
                case 'DespatchAdvice':
                    this.modulesState.despatchAdviceForm = reData.res.doc;
                    break;
                case 'ReceiptAdvice':
                case 'ReceiptAdviceRATC01':
                case 'ReceiptAdviceReturn':
                    this.modulesState.receiptAdviceForm = reData.res.doc;
                    break;
                case 'StockInNotice':
                    this.modulesState.stockInNoticeForm = reData.res.doc;
                    break;
                default:
                    break;
            }
            // 单据规则
            this.modulesState.rules = reData.res.rules;

            // 添加需要验证的字段
            this.addValidateKeys(reData.res.rules);

            // 上传文件列表
            this.modulesState.uploadList = reData.res.doc.Attachments;
            // 设置table 表单唯一key
            this.modulesState.linesKey = [];
            reData.res.doc.Lines.forEach((val, index) => {
                this.modulesState.linesKey.push(index);
            });
            // 拼装数据 已上传到 数据
            this.modulesState.uploadList = this.modulesState.uploadList.map((item) => {
                return {
                    ...item,
                    size: 1,
                    status: "done",
                    uid: item.UUID,
                    name: item.FileName,
                    url: `javascript:window.documentAttachmentGet('${item.UUID}');`,
                };
            });
            this.setModulesState(this.modulesState, () => {
                this.getCountry();
            });
        } else {
            this.goBack();
        }
    }

    /**
     * 返回首页
     */
    public goBack = () => {
        if (this.redirectURL()) {
            history.goBack();
        } else {
            history.push(`/workbench/platform/document/documentList`);
        }

    }
    /**
     * 选择公司接口
     */
    public pageListUsersList = async (params: IRequestParams): Promise<any[]> => {
        let data = await network.userNetworkMyList(this, {
            fuzzyConnectionName: params && params.name,
            pageNum: 1,
            pageSize: 1000
        });
        return data.res;
    }
    /**
     * 保存选择销售方公司
     */
    public saveSellerSupplie = (data: any) => {
        switch (this.modulesState.documentType) {
            case 'Order':
                this.modulesState.orderForm.SellerSupplierParty.ID = data[0].connectionId;
                this.modulesState.orderForm.SellerSupplierParty.Name = data[0].connectionName;
                break;
            case 'Contract':
                this.modulesState.ContractForm.SellerSupplierParty.ID = data[0].connectionId;
                this.modulesState.ContractForm.SellerSupplierParty.Name = data[0].connectionName;
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                this.modulesState.forecastForm.ReceiverParty.ID = data[0].connectionId;
                this.modulesState.forecastForm.ReceiverParty.Name = data[0].connectionName;
                break;
            case 'DespatchAdvice':
                this.modulesState.despatchAdviceForm.DeliveryCustomerParty.ID = data[0].connectionId;
                this.modulesState.despatchAdviceForm.DeliveryCustomerParty.Name = data[0].connectionName;
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                this.modulesState.receiptAdviceForm.DespatchSupplierParty.ID = data[0].connectionId;
                this.modulesState.receiptAdviceForm.DespatchSupplierParty.Name = data[0].connectionName;
                break;
            case 'StockInNotice':
                this.modulesState.stockInNoticeForm.SellerSupplierParty.ID = data[0].connectionId;
                this.modulesState.stockInNoticeForm.SellerSupplierParty.Name = data[0].connectionName;
                break;
            default:
                break;
        }
        this.modulesState.connectionCompanyId = data[0].connectionId;
        this.setModulesState(this.modulesState, () => { this.queryDocRules(); });
    }

    /**
     *  获取对应公司 单据规则
     */
    public queryDocRules = async () => {
        const param = {
            targetParty: this.modulesState.connectionCompanyId,
            docType: this.modulesState.documentType,
        };
        const reData: any = await document.documentDraftGet(this, param);
        if (!reData.er) {
            let isDiffRules: Boolean = JSON.stringify(this.modulesState.rules) === JSON.stringify(reData.res.rules);
            if (!isDiffRules) {
                Modal.warning({
                    title: '提示',
                    content: '接收方的单据接收规则与您当前单据草稿不一致，系统将自动保留相同部分内容。',
                    okText: '确定',
                });
            }
            // 保存待验证字段
            this.addValidateKeys(reData.res.rules);
            this.modulesState.rules = reData.res.rules;
            this.setModulesState(this.modulesState);
        }
    }

    /**
     * 保存修改的 订单table 同步
     */
    public changeOrderTable = (line: any, index: number) => {
        this.modulesState.orderForm.Lines[index] = line;
        this.setModulesState(this.modulesState);
    }

    /**
     * 常规单据 添加一行
     */
    public addCommonFormTable = () => {
        switch (this.modulesState.documentType) {
            case 'Order':
                if (this.modulesState.orderForm.Lines.length === 5000) {
                    message.warning('支持不超过5000行!');
                    return false;
                }
                if (!this.modulesState.orderForm.Lines.length) {
                    this.modulesState.linesKey.push(0);
                } else {
                    this.modulesState.linesKey.push(this.modulesState.linesKey[this.modulesState.linesKey.length - 1] + 1);
                }
                this.modulesState.orderForm.Lines.push({
                    DocumentReference: undefined,
                    LineReference: undefined,
                    Number: 0,
                    BuyersItemIdentification: undefined,
                    BuyersItemName: undefined,
                    BuyersItemModelName: undefined,
                    SellersItemIdentification: undefined,
                    SellersItemName: undefined,
                    SellersItemModelName: undefined,
                    Quantity: undefined,
                    LineExtensionAmount: '0.00',
                    Description: '',
                    UnitCode: 'TNE',
                    Price: '',
                    BaseQuantity: 1,
                    TaxRate: 0,
                });
                break;
            case 'Contract':
                if (this.modulesState.ContractForm.Lines.length === 5000) {
                    message.warning('支持不超过5000行!');
                    return false;
                }
                if (!this.modulesState.ContractForm.Lines.length) {
                    this.modulesState.linesKey.push(0);
                } else {
                    this.modulesState.linesKey.push(this.modulesState.linesKey[this.modulesState.linesKey.length - 1] + 1);
                }
                this.modulesState.ContractForm.Lines.push({
                    DocumentReference: undefined,
                    LineReference: undefined,
                    Number: 0,
                    BuyersItemIdentification: undefined,
                    BuyersItemName: undefined,
                    BuyersItemModelName: undefined,
                    SellersItemIdentification: undefined,
                    SellersItemName: undefined,
                    SellersItemModelName: undefined,
                    Quantity: undefined,
                    LineExtensionAmount: '0.00',
                    Description: '',
                    UnitCode: 'TNE',
                    Price: '',
                    BaseQuantity: 1,
                    TaxRate: 0,
                });
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                if (this.modulesState.forecastForm.Lines.length === 5000) {
                    message.warning('支持不超过5000行!');
                    return false;
                }
                if (!this.modulesState.forecastForm.Lines.length) {
                    this.modulesState.linesKey.push(0);
                } else {
                    this.modulesState.linesKey.push(this.modulesState.linesKey[this.modulesState.linesKey.length - 1] + 1);
                }
                this.modulesState.forecastForm.Lines.push({
                    Number: undefined,
                    BuyersItemIdentification: undefined,
                    BuyersItemName: undefined,
                    BuyersItemModelName: undefined,
                    SellersItemIdentification: undefined,
                    SellersItemName: undefined,
                    SellersItemModelName: undefined,
                    Description: '',
                    UnitCode: 'TNE',
                    ReceiveAddress: undefined,
                    ReceiveFactory: undefined,
                    ApprovalNo: undefined,
                    Quantity: undefined,
                    ForecastStageQuantity: [],
                });
                break;
            case 'DespatchAdvice':
                if (this.modulesState.despatchAdviceForm.Lines.length === 5000) {
                    message.warning('支持不超过5000行!');
                    return false;
                }
                if (!this.modulesState.despatchAdviceForm.Lines.length) {
                    this.modulesState.linesKey.push(0);
                } else {
                    this.modulesState.linesKey.push(this.modulesState.linesKey[this.modulesState.linesKey.length - 1] + 1);
                }
                this.modulesState.despatchAdviceForm.Lines.push({
                    Number: undefined,
                    DocumentReference: undefined,
                    ReceiveAddress: undefined,
                    ReceiveFactory: undefined,
                    LineReference: undefined,
                    BuyersItemIdentification: undefined,
                    BuyersItemName: undefined,
                    BuyersItemModelName: undefined,
                    SellersItemIdentification: undefined,
                    SellersItemName: undefined,
                    SellersItemModelName: undefined,
                    UnitCode: 'TNE',
                    OrderedQuantity: undefined,
                    DeliveredQuantity: undefined,
                    Description: undefined,
                    DocumentReference2: undefined,
                    LineReference2: undefined,
                });
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                if (this.modulesState.receiptAdviceForm.Lines.length === 5000) {
                    message.warning('支持不超过5000行!');
                    return false;
                }
                if (!this.modulesState.receiptAdviceForm.Lines.length) {
                    this.modulesState.linesKey.push(0);
                } else {
                    this.modulesState.linesKey.push(this.modulesState.linesKey[this.modulesState.linesKey.length - 1] + 1);
                }
                this.modulesState.receiptAdviceForm.Lines.push({
                    LineID: undefined,
                    DocumentReference: undefined,
                    LineReference: undefined,
                    BuyersItemIdentification: undefined,
                    BuyersItemName: undefined,
                    BuyersItemModelName: undefined,
                    SellersItemIdentification: undefined,
                    SellersItemName: undefined,
                    SellersItemModelName: undefined,
                    UnitCode: 'TNE',
                    DeliveredQuantity: undefined,
                    ReceivedQuantity: undefined,
                    Description: undefined,
                });
                break;
            case 'StockInNotice':
                if (this.modulesState.stockInNoticeForm.Lines.length === 5000) {
                    message.warning('支持不超过5000行!');
                    return false;
                }
                if (!this.modulesState.stockInNoticeForm.Lines.length) {
                    this.modulesState.linesKey.push(0);
                } else {
                    this.modulesState.linesKey.push(this.modulesState.linesKey[this.modulesState.linesKey.length - 1] + 1);
                }
                this.modulesState.stockInNoticeForm.Lines.push({
                    LineID: undefined,
                    DocumentReference: undefined,
                    LineReference: undefined,
                    BuyersItemIdentification: undefined,
                    BuyersItemName: undefined,
                    BuyersItemModelName: undefined,
                    SellersItemIdentification: undefined,
                    SellersItemName: undefined,
                    SellersItemModelName: undefined,
                    UnitCode: 'TNE',
                    ReceivedQuantity: undefined,
                    StockInQuantity: undefined,
                    Description: undefined,
                });
                break;
            default:
                break;
        }
        this.setModulesState(this.modulesState);
    }
    /**
     * 常规单据 删除一行
     */
    public deletCommonTable = (index: number, callBack?: any) => {
        switch (this.modulesState.documentType) {
            case 'Order':
                if (this.modulesState.orderForm.Lines.length === 1) {
                    message.warning('至少保留一行数据!');
                    return false;
                }
                this.modulesState.orderForm.Lines = this.modulesState.orderForm.Lines.filter((item, thisIndex) => {
                    return thisIndex !== index;
                });
                this.modulesState.linesKey.splice(index, 1);
                this.setModulesState(this.modulesState, () => {
                    callBack();
                });
                break;
            case 'Contract':
                if (this.modulesState.ContractForm.Lines.length === 1) {
                    message.warning('至少保留一行数据!');
                    return false;
                }
                this.modulesState.ContractForm.Lines = this.modulesState.ContractForm.Lines.filter((item, thisIndex) => {
                    return thisIndex !== index;
                });
                this.modulesState.linesKey.splice(index, 1);
                this.setModulesState(this.modulesState, () => {
                    callBack();
                });
                break;
            case 'ForecastDemand':
            case 'ForecastPrediction':
                if (this.modulesState.forecastForm.Lines.length === 1) {
                    message.warning('至少保留一行数据!');
                    return false;
                }
                this.modulesState.forecastForm.Lines = this.modulesState.forecastForm.Lines.filter((item, thisIndex) => {
                    return thisIndex !== index;
                });
                this.modulesState.linesKey.splice(index, 1);
                this.setModulesState(this.modulesState);
                break;
            case 'DespatchAdvice':
                if (this.modulesState.despatchAdviceForm.Lines.length === 1) {
                    message.warning('至少保留一行数据!');
                    return false;
                }
                this.modulesState.despatchAdviceForm.Lines = this.modulesState.despatchAdviceForm.Lines.filter((item, thisIndex) => {
                    return thisIndex !== index;
                });
                this.modulesState.linesKey.splice(index, 1);
                this.setModulesState(this.modulesState);
                break;
            case 'ReceiptAdvice':
            case 'ReceiptAdviceRATC01':
            case 'ReceiptAdviceReturn':
                if (this.modulesState.receiptAdviceForm.Lines.length === 1) {
                    message.warning('至少保留一行数据!');
                    return false;
                }
                this.modulesState.receiptAdviceForm.Lines = this.modulesState.receiptAdviceForm.Lines.filter((item, thisIndex) => {
                    return thisIndex !== index;
                });
                this.modulesState.linesKey.splice(index, 1);
                this.setModulesState(this.modulesState);
                break;
            case 'StockInNotice':
                if (this.modulesState.stockInNoticeForm.Lines.length === 1) {
                    message.warning('至少保留一行数据!');
                    return false;
                }
                this.modulesState.stockInNoticeForm.Lines = this.modulesState.stockInNoticeForm.Lines.filter((item, thisIndex) => {
                    return thisIndex !== index;
                });
                this.modulesState.linesKey.splice(index, 1);
                this.setModulesState(this.modulesState);
                break;
            default:
                break;
        }

    }
    /**
     * 计划单(拆分)
     */
    public splitQuantity = (index: number) => {
        if (this.modulesState.forecastForm.Lines[index].ForecastStageQuantity.length === 10) {
            message.warning('最多可拆分10次');
            return false;
        }
        this.modulesState.forecastForm.Lines[index].ForecastStageQuantity.push({
            Date: undefined,
            Quantity: undefined,
        });
        this.setModulesState(this.modulesState);
    }
    /**
     * 计划单据(拆分) 删除
     */
    public deletesplitQuantity = (rowIndex, index) => {
        this.modulesState.forecastForm.Lines[rowIndex].ForecastStageQuantity.splice(index, 1);
        this.setModulesState(this.modulesState);
    }
    /**
     * 后台发送计算小计
     */
    public documentCalculate = async (lines: any) => {
        let param = {
            DocumentType: this.modulesState.documentType,
            Lines: lines,
        };
        const res = await document.documentCalculate(this, param);
        if (!res.er) {
            switch (this.modulesState.documentType) {
                case 'Order':
                    res.res.Lines.forEach((item, index) => {
                        if(this.modulesState.orderForm.Lines[index]){
                            this.modulesState.orderForm.Lines[index].LineExtensionAmount = item.LineExtensionAmount;
                        }
                    });
                    this.modulesState.orderForm.Total = res.res.Total;
                    this.setModulesState();
                    break;
                case 'Contract':
                    res.res.Lines.forEach((item, index) => {
                        if(this.modulesState.ContractForm.Lines[index]){
                            this.modulesState.ContractForm.Lines[index].LineExtensionAmount = item.LineExtensionAmount;
                        }   
                    });
                    this.modulesState.ContractForm.Total = res.res.Total;
                    this.setModulesState();
                    break;
                default:
                    break;
            }

        }
    }
    /**
     * 获取回调地址
     */
    public redirectURL = () => {
        //判断是否跳转
        const redirectURL = JSString.getQueryString(window.location.search, 'redirectURL');
        return redirectURL;
    }
    /**
     * 获取appkey
     */
    public getAppKey = () => {
        //判断是否跳转
        const appKey = JSString.getQueryString(window.location.search, 'appKey');
        return appKey;
    }
    /**
     * 提交数据 (新建)
     */
    public documentCreat = async (param: any) => {
        const res = await document.documentCreate(this, param);
        if (!res.er) {
            let documentType = this.modulesState.documentType;
            if (this.redirectURL()) {
                AppSdk.instance.openApp(this, {
                    appKey: this.getAppKey(),
                    openType: 1,
                    routing: this.redirectURL(),
                    parameter: {
                        status: '草稿',
                        documentUuid: res.res.documentUUID
                    }
                });
            } else {
                history.push(`/workbench/platform/document/editDocument/${documentType}/${res.res.documentUUID}`);
                this.initData(documentType, res.res.documentUUID, undefined);
            }
            message.success("创建成功");
        }
    }
    /**
     * 发送
     */
    public documentSend = async (param: any) => {
        let params = {
            content: { ...param },
            documentUUID: this.modulesState.documentUUID ? this.modulesState.documentUUID : undefined,
        };
        const res = await document.documentSend(this, params);
        if (!res.er) {
            message.success("发送成功");
            if (this.redirectURL()) {
                AppSdk.instance.openApp(this, {
                    appKey: this.getAppKey(),
                    openType: 1,
                    routing: this.redirectURL(),
                    parameter: {
                        status: '已发送',
                        documentUuid: res.res.documentUUID
                    }
                });
            } else {
                history.push(`/workbench/platform/document/documentDetail/${res.res.documentUUID}`);
            }
            // this.goBack();
        }
    }
    /**
     * 提交数据 (修改)
     */
    public documentEdit = async (param: any) => {
        let params = {
            content: { ...param },
            documentUUID: this.modulesState.documentUUID,
        };
        const res = await document.documentUpdate(this, params);
        if (!res.er) {
            if (this.redirectURL()) {
                AppSdk.instance.openApp(this, {
                    appKey: this.getAppKey(),
                    openType: 1,
                    routing: this.redirectURL(),
                    parameter: {
                        status: '草稿',
                        documentUuid: this.modulesState.documentUUID
                    }
                });
            }
            message.success("修改成功");
            // this.goBack();
        }
    }
    /** 获取国家列表 */
    public getCountry = async () => {
        const res = await createCompany.country(this, null);
        if (!res.er) {
            this.modulesState.countryList = res.res.countryList;
            this.setModulesState(this.modulesState, () => {
                switch (this.modulesState.documentType) {
                    case 'Order':
                        this.getProvince(this.modulesState.orderForm.DeliveryAddress.Country);
                        break;
                    case 'ForecastDemand':
                    case 'ForecastPrediction':
                        break;
                    case 'DespatchAdvice':
                        this.getProvince(this.modulesState.despatchAdviceForm.DeliveryAddress.Country);
                        break;
                    case 'ReceiptAdvice':
                    case 'ReceiptAdviceRATC01':
                    case 'ReceiptAdviceReturn':
                        break;
                    case 'DebitNote':
                        break;
                    default:
                        break;
                }
            });
        }
    }
    /** 获取省 */
    public getProvince = async (province) => {

        let countryCode = this.modulesState.countryList.filter((item: any) => {
            return item.code === province;
        });
        const res = await createCompany.state(this, { countryCode: countryCode[0] ? countryCode[0].code : '' });
        if (!res.er) {
            this.modulesState.provinceList = res.res.provinceList;
            this.modulesState.cityList = [];
            this.setModulesState();
        }
    }
    /** 获取省 */
    public getCity = async (province) => {

        let provinceCode = this.modulesState.provinceList.filter((item: any) => {
            return item.name === province;
        });
        const res = await createCompany.city(this, { stateCode: provinceCode[0].code });
        if (!res.er) {
            this.modulesState.cityList = res.res.cityList;
            this.setModulesState();
        }
    }
    /**
     * 限制 选择时间小于当前时间 (注: 需求改动,需要选择之后的日期)
     */
    public disabledDate = (Value) => {
        return false;
        // if (!Value) {
        //     return false;
        // }
        // let nowDate = new Date();
        // return Value.valueOf() > nowDate.valueOf();
    }
    /**
     * 时间戳 转 格式日期
     */
    public timeStampToFormat = (Value: any) => {
        return Value && !isNaN(Value) ? moment(Field.formatTime(parseInt(Value, 10)), this.modulesState.dateFormat) : undefined;
    }
    /**
     * base64转数组
     */
    public base64ToArrayBuffer = (base64) => {
        let binaryString = window.atob(base64);
        let len = binaryString.length;
        let bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }
    /**
     * 下载查看文件
     */
    public documentAttachmentGet = async (uuid: string) => {
        const res = await document.documentAttachmentGet(this, { uuid: uuid });
        if (!res.er) {
            let debug = this.base64ToArrayBuffer(res.res.base64Content);
            let blob = new Blob([debug], { type: res.res.mimeType });
            let data = blob;
            let a = window.document.createElement('a');
            let url = window.URL.createObjectURL(data);
            a.href = url;
            a.download = res.res.fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }

    /**
     * 保存上传文件列表
     */
    public setUploadFile = (fileList: any) => {
        let suceessFiles = [];
        fileList.forEach((element, index) => {
            if (element.UUID) {
                suceessFiles.push(fileList[index]);
                suceessFiles[index].url = `javascript:window.documentAttachmentGet('${element.UUID}');`;
            }
            if (element.status === 'done' && element.response && element.response.ok) {
                if (element.response.body[0].UUID) {
                    suceessFiles.push(fileList[index]);
                    suceessFiles[index].url = `javascript:window.documentAttachmentGet('${element.response.body[0].UUID}');`;
                } else {
                    message.error('上传失败');
                }
            }
            if (element.status === 'uploading') {
                suceessFiles.push(fileList[index]);
            }
        });
        this.modulesState.uploadList = suceessFiles;
        this.setModulesState(this.modulesState);
    }
    /**
     * 上传设置
     */
    public uploadSet() {
        const { user } = MyStore.instance.getState();
        window['documentAttachmentGet'] = this.documentAttachmentGet;
        const fileNumber = 20; // 20个数量限制
        const size = 5; // 5M大小
        return {
            action: `${serverDomain()}${Urls.documentAttachmentCreate}`,
            headers: {
                Authorization: user.cToken || undefined
            },
            onChange: ({ file, fileList }: any) => {
                fileList = fileList.filter((item: any, index: any) => {
                    const isLt5M = item.size / 1024 / 1024 < size;
                    return isLt5M && index < fileNumber;
                });

                this.setUploadFile(fileList);
            },
            beforeUpload: (file: any) => {
                const length = this.modulesState.uploadList.length;
                if (length >= fileNumber) {
                    message.error(`附件数量不超过${fileNumber}个附件`);
                }
                const isLt5M = file.size / 1024 / 1024 < size;
                if (!isLt5M) {
                    message.error(`文件大小不能超过${size}M`);
                }
                return isLt5M;
            },
            defaultFileList: this.modulesState.uploadList,
        };
    }

    /** 
     * 获取自定义表单字段模板(文本输入,时间,下拉)---单据字段添加
     * @param formData 不同单据的数据
     * @param form antd form表单属性
     * @param formItemLayout 显示样式
     * @param isLine 是否为行添加的字段
     * @param Colspan Col span样式默认24
     */
    public getExtraTemplate = (formData, form, formItemLayout, isLine, colspan: number = 24, lineIndex: number = null) => {
        let rules = isLine ? this.modulesState.rules.Lines.Extra : this.modulesState.rules.Extra;
        let templateArr = [];
        for (let key of Object.keys(rules)) {
            if(rules[key].type === 2){ // 自定义字段
                templateArr.push(
                    <Col span={colspan} key={key}>
                        <UITemplateFormItem
                            form={form}
                            rules={rules[key]}
                            keyName={key}
                            isLine={isLine}
                            formData={formData}
                            lineIndex={lineIndex}
                            formItemLayout={formItemLayout}
                            linesKey={this.modulesState.linesKey}
                        />
                    </Col>
                );
    
            }
        }
        return templateArr;
    }

    /**
     * 获取系统表单字段规则 模板
     * @param name 字段名称
     * @param isLine 是否为行单据 默认false
     */
    public getExtraRules = (name, isLine = false) => {
        const rules = this.modulesState.rules;
        let ruleObj = {};
        if (isLine && rules.Lines[name]) {
            ruleObj = {
                pattern: this.evilFun(rules.Lines[name].regex),
                message: rules.Lines[name].invalidTip,
                validator: undefined,
            };
        }
        if (!isLine && rules[name]) {
            ruleObj = {
                pattern: rules[name].regex ? this.evilFun(rules[name].regex) : /^/,
                message: rules[name].invalidTip,
                validator: undefined,
            };
        }
        return ruleObj;
    }

    /**
     * 字符串转函数(字符串转正则)
     */
    public evilFun = (fn) => {

        let Fn = Function;
        try {
            return new Fn('return ' + fn)();
        } catch{
            return /^/;
        }
    }

    /**
     * 提交表单时 过滤自定义时间字段 转换为时间戳
     * @param values 字段对象集
     * @param isLine 是否为行单据 默认false
     */
    public DateformatToTimeStamp = (values, isLine = false) => {
        const rules = isLine ? this.modulesState.rules.Lines.Extra : this.modulesState.rules.Extra;
        for (let keyName of Object.keys(values)) {
            if (rules[keyName] && (rules[keyName].inputType === 'DATE' || rules[keyName].inputType === 'DATETIME')) {
                values[keyName] = values[keyName] ? values[keyName].valueOf() : undefined;
            }
        }
        return values;
    }
    /**
     * 提交表单时 添加自定义字段到表单
     * @param values 提交数据
     * @param isLine 是否为行单据 默认false
     */
    public addExtraForm = (values, isLine = false) => {
        const rules = isLine ? this.modulesState.rules.Lines.Extra : this.modulesState.rules.Extra;
        let objs = {};
        for (let keyName of Object.keys(rules)) {
            if(rules[keyName].type === 2){  // 自定义字段
                objs[keyName] = values[keyName];
            }
        }
        return objs;
    }
    /** 添加需要验证的字段 */
    private addValidateKeys = (validateFields) => {
        // 保存待验证字段
        if (validateFields) {
            this.modulesState.validateKeys = {};
            const extraFields = validateFields.Extra;
            const linesFields = validateFields.Lines.Extra;
            for(let extra of Object.keys(extraFields)){
                if(extraFields[extra].newVerifyRules){
                    this.modulesState.validateKeys[extra] = extraFields[extra];
                }
            }
            for(let line of Object.keys(linesFields)){
                if(linesFields[line].newVerifyRules){
                    this.modulesState.validateKeys[line] = linesFields[line];
                }
            }
        }
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/Document/EditDocument/Modules.Action.tsx